import { render, staticRenderFns } from "./personal-search-full.vue?vue&type=template&id=2846cc03&"
import script from "./personal-search-full.vue?vue&type=script&lang=js&"
export * from "./personal-search-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/administracion-frontend/administracion-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2846cc03')) {
      api.createRecord('2846cc03', component.options)
    } else {
      api.reload('2846cc03', component.options)
    }
    module.hot.accept("./personal-search-full.vue?vue&type=template&id=2846cc03&", function () {
      api.rerender('2846cc03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-personal/personal-search-full/personal-search-full.vue"
export default component.exports